export const blueTheme = {
  body: "#ffffff",
  text: "#001C55",
  expTxtColor: "#000a12",
  highlight: "#A2ABB5",
  dark: "#00072D",
  secondaryText: "#7F8DAA",
  imageHighlight: "#0E6BA8",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#0A2472",
  headerColor: "#0E6BA877",
  splashBg: "#001C55",
};
export const chosenTheme = blueTheme;
